<mat-button-toggle
  class="rounded"
  [checked]="settingsMenuOpen()"
  [matMenuTriggerFor]="menu"
  (change)="settingsMenuOpen.set($event.source.checked)"
>
  <mat-icon color="primary">settings_outlined</mat-icon>
</mat-button-toggle>

<mat-menu class="manageMenu" #menu="matMenu" (closed)="onSettingsMenuClosed()">
  <h4 class="text-bold">Actions</h4>

  <button (click)="newCase()" mat-menu-item>
    <span>Report a new case (event or issue)</span>
  </button>

  <button (click)="goOutsideApp(requestControlChange)" mat-menu-item>
    <span>Request a control change</span>
  </button>

  <button (click)="goOutsideApp('https://swissreesm.service-now.com/contactone?id=request_access_rights')" mat-menu-item>
    <span>Request access</span>
  </button>

  <button (click)="goOutsideApp(environmentVariables.reportBugContactOneUrl)" mat-menu-item>
    <span>Report bug</span>
  </button>

  <mat-divider></mat-divider>

  <h4 class="text-bold">Dashboards and reports</h4>

  <button (click)="goOutsideApp(environmentVariables.OperationalRiskDashboard)" mat-menu-item>
    <span>Operational Risk Dashboards</span>
  </button>
</mat-menu>

<mat-button-toggle class="rounded" [checked]="helpMenuOpen()" [matMenuTriggerFor]="help" (change)="helpMenuOpen.set($event.source.checked)">
  <mat-icon color="primary">help_outline</mat-icon>
</mat-button-toggle>

<mat-menu class="manageMenu" #help="matMenu" (closed)="onHelpMenuClosed()">
  <h4 class="text-bold">What's new</h4>

  <button (click)="goOutsideApp('https://wiki.swissre.com/pages/viewpage.action?pageId=396202449')" mat-menu-item>
    <span>OneORM - Release log</span>
  </button>

  <mat-divider></mat-divider>

  <h4 class="text-bold">OneORM - Help</h4>

  <button (click)="infoDialog.setInfoData('RCSA')" mat-menu-item>
    <span>RCSA</span>
  </button>

  <button (click)="infoDialog.setInfoData('Event')" mat-menu-item>
    <span>Event reporting</span>
  </button>

  <button (click)="infoDialog.setInfoData('Issue')" mat-menu-item>
    <span>Issue management</span>
  </button>

  @if (environmentVariables.libraryControlsEnabled) {
    <button (click)="infoDialog.setInfoData('CCMT')" mat-menu-item>
      <span>Control change management (CCMT)</span>
    </button>
  }

  <mat-divider></mat-divider>

  <h4 class="text-bold">OneORM - User Guidance</h4>

  <button (click)="goOutsideApp('https://swissre.sharepoint.com/sites/team-GRACE/SitePages/User%20Guidance.aspx')" mat-menu-item>
    <span>User Guidance</span>
  </button>

  <button (click)="onFaqLinkClick()" mat-menu-item>
    <span>Frequently asked questions (FAQ)</span>
  </button>

  <mat-divider></mat-divider>

  <h4 class="text-bold">ORM - Standards</h4>

  <button (click)="goOutsideApp('https://swissre.sharepoint.com/sites/policymanagement/PMTPublishedDocuments/5/T000643.pdf')" mat-menu-item>
    <span>Group Operational Risk Management (ORM)</span>
  </button>

  <button
    (click)="goOutsideApp('https://swissre.sharepoint.com/sites/policymanagement/PMTPublishedDocuments/5/T0001620.pdf')"
    mat-menu-item
  >
    <span>Targeted Standard on Operational Risk and Control Framework</span>
  </button>

  <button
    (click)="
      goOutsideApp(
        'https://swissre.sharepoint.com/sites/GroupORM_Central/Templates/Guidance%20Reference%20Documents/Additional%20Guidance%20on%20Mapping%20Internal%20Controls%20to%20Legal%20Entities.pdf'
      )
    "
    mat-menu-item
  >
    <span>Additional Guidance on Mapping Internal Controls to Legal Entities</span>
  </button>

  <button
    (click)="
      goOutsideApp(
        'https://swissre.sharepoint.com/:b:/r/sites/GroupORM_Central/Templates/Guidance%20Reference%20Documents/Additional%20guidance%20on%20OE%203.pdf'
      )
    "
    mat-menu-item
  >
    <span>Additional guidance on Op <br />Event Reporting</span>
  </button>

  <button
    (click)="
      goOutsideApp(
        'https://swissre.sharepoint.com/:b:/r/sites/GroupORM_Central/Templates/Guidance%20Reference%20Documents/Additional%20guidance%20on%20Issue.pdf'
      )
    "
    mat-menu-item
  >
    <span>Additional guidance on Issue <br />Management</span>
  </button>
</mat-menu>

<div style="display: none">
  <app-user-guide #infoDialog />
</div>
